import { render, staticRenderFns } from "./PublishPrefs.vue?vue&type=template&id=0b983422&scoped=true"
import script from "./PublishPrefs.vue?vue&type=script&lang=js"
export * from "./PublishPrefs.vue?vue&type=script&lang=js"
import style0 from "./PublishPrefs.vue?vue&type=style&index=0&id=0b983422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b983422",
  null
  
)

export default component.exports